import React from 'react'

const BenefitsIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.34483 1.90181C7.72083 1.5756 8.2795 1.5756 8.65549 1.90181L9.08205 2.27189C9.31405 2.47317 9.62568 2.55667 9.92724 2.49836L10.4817 2.39114C10.9704 2.29663 11.4542 2.57597 11.6167 3.04647L11.8011 3.58024C11.9014 3.87056 12.1295 4.09869 12.4198 4.19897L12.9536 4.38333C13.4241 4.54585 13.7035 5.02967 13.6089 5.5184L13.5017 6.07284C13.4434 6.3744 13.5269 6.68604 13.7282 6.91804L14.0983 7.34459C14.4245 7.72058 14.4245 8.27926 14.0983 8.65525L13.7282 9.0818C13.5269 9.3138 13.4434 9.62543 13.5017 9.927L13.6089 10.4814C13.7035 10.9702 13.4241 11.454 12.9536 11.6165L12.4198 11.8009C12.1295 11.9011 11.9014 12.1293 11.8011 12.4196L11.6167 12.9534C11.4542 13.4239 10.9704 13.7032 10.4817 13.6087L9.92724 13.5015C9.62568 13.4432 9.31405 13.5267 9.08205 13.7279L8.65549 14.098C8.2795 14.4242 7.72083 14.4242 7.34483 14.098L6.91828 13.7279C6.68628 13.5267 6.37465 13.4432 6.07309 13.5015L5.51864 13.6087C5.02992 13.7032 4.54609 13.4239 4.38358 12.9534L4.19921 12.4196C4.09893 12.1293 3.8708 11.9011 3.58049 11.8009L3.04672 11.6165C2.57621 11.454 2.29687 10.9702 2.39138 10.4814L2.4986 9.927C2.55692 9.62543 2.47342 9.3138 2.27213 9.0818L1.90206 8.65525C1.57585 8.27926 1.57585 7.72058 1.90206 7.34459L2.27213 6.91804C2.47342 6.68603 2.55692 6.3744 2.4986 6.07284L2.39138 5.5184C2.29687 5.02967 2.57621 4.54585 3.04672 4.38333L3.58049 4.19897C3.8708 4.09869 4.09893 3.87056 4.19921 3.58024L4.38358 3.04647C4.54609 2.57597 5.02992 2.29663 5.51864 2.39114L6.07309 2.49836C6.37465 2.55667 6.68628 2.47317 6.91828 2.27189L7.34483 1.90181Z"
                fill="#11A670"
                stroke="#11A670"
            />
            <path d="M10.6668 5.33325L5.3335 10.6666" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M6.03174 6.10815H6.05052"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M10.0317 10.1082H10.0505"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}

export default BenefitsIcon
